import React, { useState } from 'react';
//import dadesbancaries from '../data/dadesbancaries.json'
//import assignatures from '../data/assignatures.json'
import llista_bonificacions from '../../../data/llista_bonificacions.json'
import config from '../../../config';
import { textPlaAHtml, htmlDesat } from './formatText'

// abans es carregaven amb require() en temps de build; ara arriben en viu des de l'API
// (amb el mateix fallback als JSON estàtics al servidor), injectades per studies.*.js
// via setCataleg() un cop resolt el fetch
let dadesbancaries = {}
let assignatures = {}

export function setCataleg(novesAssignatures, novesDadesBancaries) {
  assignatures = novesAssignatures ?? assignatures
  dadesbancaries = novesDadesBancaries ?? dadesbancaries
}


const exemptPagament = (iddocument,becat) => {
  if( becat === "B") return true;
  //if(!iddocument?.length) return false;
  //return llistaExemptesPagament.filter( id => id === iddocument ).length > 0
  return false
}

const exemptPagamentAmbLlibres = (iddocument,becat) => {
  if( becat === "L") return true;
  //if(!iddocument?.length) return false;
  //return llistaExemptesPagamentAmbLlibres.filter( id => id === iddocument ).length > 0
  return false
}


export function calculQuota(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat ) {

let quota = {
             matricula: 0,
             asseguranca: 0,
             material: 0,
             formacio: 0,
             bonificacio: 0,
             moduls: 0,
             total: 0,
             dadesbancaries: dadesbancaries }

/* controls que impedeixen que es calcul la quota sense tenir les dades corresponents necessaries per al càlcul */
if(dataNaixement === undefined) return quota
if(curs === undefined) return quota
if(curs?.id === undefined) return quota
if (!assignatures[curs.id]) return quota // catàleg encara no ha arribat de l'API


// En cas de ser exemptes de pagament no marquem per defecte ampa
if(exemptPagament(iddocument,becat))
  {
    materials.map( (m) => { if( m.id == "ampa") { m.checked = false} } )
  }


// busquem nivell maxim de assignatura (només cal que en tinguin una de 2n per ser matricula de 2n curs)
let nivellMax = 0
const llistaAssignatures = assignatures[curs.id]
  llistaAssignatures.map((ll) => {
    ll.subjects.map((s) => { 

      if(assignaturesTriades.includes(s.id))
      {
          if(s.level > nivellMax)
          {
              nivellMax = s.level
          }
        }
    }
    )
  })

  setNivellMax(nivellMax)

  //if(nivellMax === 2 && !props.nouAlumne ) setRepetidor(2)



let temps= new Date()
temps.setFullYear(new Date().getFullYear() - 28)

  quota.menor28 = dataNaixement.getTime() >= temps.getTime() ? true : false

  const quotaAsseguranca = (menor28) => {

    if (menor28) {
      return 1.15
    }
      
    return 0
  }

  const quotaMaterial = (curs) => {

    if (curs.material === undefined ) return 0

    if(materials.length === 0 )  // inicial
    {
      let mats = []

      curs.material.map((m) => 
      { 
            return mats.push({...m,checked: m.check })
      })

      //console.log("MATS",mats)

      setMaterials(mats)
    }


    let totalMaterials =  0

      materials.map((m) => 
      { 

          if(m.checked) totalMaterials += m.preu
            
      })

      
    return totalMaterials
  }

  const quotaBonificacio = (matricula,bonificacio) => {

    const bon = llista_bonificacions.filter(b => b.id === bonificacio ).pop()

    if (!bon) return 0

    switch (bon.descompte) {
      case '50%': return matricula / 2;
      case '100%': return matricula;
      default: return 0;
    }
  }


const quotaCFGM = (quota, assignaturesTriades ) => {

//const preuUF = 25
const preuFCT = 10

  // assegurança + despeses
  quota.asseguranca = quotaAsseguranca(quota.menor28) 
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT.2/.test(assignaturesTriades[0])) {

    quota.moduls = preuFCT;

  } else {

    const llistaPreus = []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      bloc.subjects.map(
        (assignatura) => {

          llistaPreus[assignatura.id] = assignatura.preu
          //console.log("BL L",assignatura.id,assignaturesTriades,assignaturesTriades.includes(assignatura.id));

          if (assignatura.level === 1) {

            llistaAssignaturesPrimer.push(assignatura.id)

            // les FCT no compten com a modul
            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
            }

          }

          if (assignatura.level === 2) {

            llistaAssignaturesSegon.push(assignatura.id)

            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
            }
          }

        }
      )
    }
    )

    /*
    //console.log("Blocs",Object.keys(llistaBlocs).length,llistaBlocs)
    //console.log(llistaAssignaturesPrimer)

    matricula_parcial_1r = true;
    //matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    //matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    if (matricula_parcial_1r && matricula_parcial_2n) {
      // Les FCT de primer no computen com a assignatura a pagar 
      assignaturesTriades.filter((ass) => !/^FCT/.test(ass)).map((ass) => {  quota.material += llistaPreus[ass] })
      assignaturesTriades.filter((ass) => !/^FCT/.test(ass)).map((ass) => {  quota.matricula += preuUF })

      quota.matricula += ( preuFCT * assignaturesTriades.filter((ass) => /^FCT.2/.test(ass)).length)

    }
    else {
      quota.matricula = preuMatricula
    }
      */


    /* REFEM CALCUL */

    quota.matricula = 0
    assignaturesTriades.filter((ass) => {  quota.matricula += llistaPreus[ass] })

   // assignaturesTriades.filter((ass) => !/^FCT/.test(ass)).map((ass) => {  quota.matricula += preuUF })
   //quota.matricula += ( preuFCT * assignaturesTriades.filter((ass) => /^FCT.2/.test(ass)).length)

    //DEBUG console.log("CALCUL", quota.matricula,quota.material)

    /* moduls */
    quota.moduls = 0

    /*
    if (matricula_parcial_1r && matricula_parcial_2n) {
      // Les FCT de primer no computen com a assignatura a pagar pero les de segon en matricula parcial si
      quota.moduls = ( preuFCT * assignaturesTriades.filter((ass) => /^FCT.2/.test(ass)).length)
    }

    //console.log("PARCIAL 1",matricula_parcial_1r)
    //console.log("PARCIAL 2",matricula_parcial_2n)

    // preu 1r
    if (matricula_parcial_1r) {
      quota.moduls += preuModuls1 * Object.keys(llistaBlocsPrimer).length
    }

    // preu 2n
    if (matricula_parcial_2n) {
      quota.moduls += preuModuls2 * Object.keys(llistaBlocsSegon).length
    }
    */


  }

  quota.total += quota.moduls + quota.matricula


  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material
    quota.material = 0
  }
  else {
    quota.material += quotaMaterial(curs)
  }
  quota.total += quota.material

  // total
  return quota;
}




// iniciem a 'null'
let formacio = undefined
let llistaAssignaturesPrimer =  []
let llistaAssignaturesSegon =  []
let matricula_parcial_1r = true;
let matricula_parcial_2n = true;
//let matricula_parcial_1r_count = 0;
//let matricula_parcial_2n_count = 0;

quota.asseguranca = 0;
quota.material = 0;
quota.total = 0;

switch(curs.id)
{
     // ESO 1 i 2
     case "ESOLOE01": 
     case "ESOLOE01C":  // continuitat
     case "ESOLOE02": 
     case "ESOLOE02C":  // continuitat
     // ESO 3 i 4
     case "ESOLOE03": 
     case "ESOLOE03C":  // continuitat
     case "ESOLOE04": 
     case "ESOLOE04C":  // continuitat
     case "ESOLOE04CT":  // cientific tecnologic
     case "ESOLOE04HS":  // humanitats social
     case "ESOLOE04A":   // artistic
     case "ESOLOE04CF":  // cicles
                        // assegurança
                        //quota.asseguranca = quotaAsseguranca(quota.menor28)
                        quota.asseguranca = 0
                        quota.total += quota.asseguranca

                        quota.matricula = 0
                        quota.total += quota.matricula

                        // material
                        quota.material = quotaMaterial(curs)
                        quota.total += quota.material

                        // total
                        return quota;

     // BATX 1 i 2
    case "BATXLOE1000": 
    case "BATXLOE2000": 
    case "BATXLOE3000": 
    case "BATXLOE10001": 
    case "BATXLOE10002": 
    case "BATXLOE20001C": 
    case "BATXLOE20001CTC": 
    case "BATXLOE20002C": 
    case "BATXLOE20001T": 
    case "BATXLOE20002T": 
    case "BATXLOE30001H": 
    case "BATXLOE30001HSC": 
    case "BATXLOE30002H": 
    case "BATXLOE30001S": 
    case "BATXLOE30002S": 

     // BATX NOCTURN
    case "BATXLOE20001NC":
    case "BATXLOE20002NC":
    case "BATXLOE30001NHS":
    case "BATXLOE30002NHS":

                        // assegurança
                        //quota.asseguranca = quotaAsseguranca(quota.menor28)
                        quota.asseguranca = 0
                        quota.total += quota.asseguranca

                        quota.matricula = 0
                        quota.total += quota.matricula

                        // material
                        quota.material = quotaMaterial(curs)
                        quota.total += quota.material
                        // total
                        return quota;

 // BATXILLERAT REPETIDORS
    case "BATXLOE1000R": 
    case "BATXLOE2000R": 
    case "BATXLOE3000R": 
    case "BATXLOE10001R": 
    case "BATXLOE10002R": 
    case "BATXLOE20001CR": 
    case "BATXLOE20002CR": 
    case "BATXLOE20001TR": 
    case "BATXLOE20002TR": 
    case "BATXLOE30001HR": 
    case "BATXLOE30002HR": 
    case "BATXLOE30002SR": 
    case "BATXLOE30002SR": 

     // BATX NOCTURN REPETIDORS
    case "BATXLOE20001NCR":
    case "BATXLOE20002NCR":
    case "BATXLOE30001NHSR":
    case "BATXLOE30002NHSR":

                        // assegurança
                        //quota.asseguranca = quotaAsseguranca(quota.menor28)
                        quota.asseguranca = 0
                        quota.total += quota.asseguranca

                        quota.matricula = 0
                        quota.total += quota.matricula

                        // TODO - Cal comptar exactament les assignatures
                        console.log("CURS",assignatures[curs.id],assignaturesTriades.length)
                        //< assignatures[curs.id].subjects.length )

                        if(assignaturesTriades.length  < 7)
                        {
                          quota.material = 30
                        } else{
                          quota.material = quotaMaterial(curs)
                        }

                        // material
                        quota.total += quota.material
                        // total
                        return quota;

  default: return quota;
      
}

}


/*****************************************
 * 
 * MostraQuota
 * 
 * 
 * 
 */

export const MostraQuota = (props)  => {

let quota = props.quota
const [bonificacio, setBonificacio] = useState([]);

const handleChangeRepetidor = (v) => {
  props.setRepetidor(v)

  //checkMaterials()
}


const canviaPreuMaterial = (id,preu) => {

let mat = [...props.materials]

  mat.filter(item => item.id === id).map( (m) => m.preu = preu )

  props.setMaterials(mat)

}

const canviaTxtMaterial = (id,txt) => {

let mat = [...props.materials]

  mat.filter(item => item.id === id).map( (m) => m.txt = txt )

  props.setMaterials(mat)

}


const handleChangeMaterial = (t) => {

//console.log("MAT0",t)

let mat = [...props.materials]

//console.log("MAT1",mat)

  mat.filter(item => item.id === t).map( (i) => i.checked = !i.checked )

//console.log("MAT2",mat)

  props.setMaterials(mat)

}

const isMaterialChecked = (id) => {

let mat = props.materials.filter(item => item.id === id).pop()

if(mat === undefined ) return false
return mat.checked
}


const handleChangeBonificacions = (t) => {
  //console.log(t)
  props.setBonificacions(t)
  setBonificacio(t)
}

const handleChangeTerminis = (t) => {
  props.setDosTerminis(t)
}


// calcul quotes  / terminis
//console.log("2T", props.dosTerminis);
if (props.dosTerminis) {

  switch(props.cicle)
  {

    // Taxes 1r i resta 2n
    case "CFGS": 
      quota.termini1 =  quota.matricula - quota.bonificacio
      quota.termini2 =  quota.total - quota.termini1
        break

    // 50%
    default:
    case "CFGM": 
        quota.termini1 =  quota.total / 2
        quota.termini2 =  quota.total - quota.termini1
        break
  }

}
else {
  quota.termini1 = undefined
  quota.termini2 = undefined
}

let enguany = new Date().getFullYear()
let anyVinent = enguany + 1
anyVinent = anyVinent.toString().slice(-2)

  return (
    <div className="col col-12">

      <div className="row">
        <div className="t-Form-labelContainer">
          <label className="t-Form-label"> Quota de pagament del curs escolar {enguany}/{anyVinent}</label>
        </div>
      </div>

      <div className="row">
      <div className="col quota">


        <div className="quotaTitol">Curs: {props.curs.value} ({props.curs.id})</div>

        <div className="quotaDadesBancaries">

        { quota.total >0 && ( quota.dadesbancaries.IBAN && ( <>

          <div><span className="quotaNomCamp">Entitat bancària:</span> <span dangerouslySetInnerHTML={textPlaAHtml(quota.dadesbancaries.entitat)} /></div>

          <div> <span className="quotaNomCamp">nº IBAN:</span> <span dangerouslySetInnerHTML={textPlaAHtml(quota.dadesbancaries.IBAN)} /></div>

          </>) ) }

          <div className="quotaDadesPagamentCalendari"><span className="quotaNomCamp">Condicions:</span> <span dangerouslySetInnerHTML={htmlDesat(quota.dadesbancaries.condicions[props.curs.condicions])} /></div>

        </div>

        <label> Conceptes </label>

        <table className="quota table">
          <tbody>

              { ( !props.curs.id.startsWith("ESO") && !props.curs.id.startsWith("BATX") ) &&
                (<>
                  <tr>
                    <th className="quotaNomCamp" colspan="2">Assegurança escolar obligatòria: </th>
                  </tr>

                  <tr>
                    {quota.menor28 && (<td className="col">Alumnat menor de 28 anys</td>)}
                    {!quota.menor28 && (<td className="col">Alumnat de 28 anys i major</td>)}
                    <td>{(quota.asseguranca).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td>
                  </tr>
                </>) }


          { quota.moduls > 0 && (
          <tr>
            <td>Material mòduls matriculats:</td>
            <td>{(quota.moduls).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
            </td>
          </tr>)
          }

          { quota.matricula > 0 && (
          <tr>
            <td>{ props.curs.id.startsWith("CFPM") ? "Material curs:" : "Taxes:" }</td>
            <td>{(quota.matricula).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
            </td>
          </tr>)
          }



          {props.curs?.bonificacions === true && (<tr><th colspan="2" className="quotaNomCamp">Bonificacions / Exempcions:</th></tr>)}


          {props.curs?.bonificacions === true && (
                <tr>
                  <td>
                    <select id="bonificacions" name="bonificacions" defaultValue={bonificacio} onChange={(e) => handleChangeBonificacions(e.target.value)}>
                      {llista_bonificacions.map((m, k) =>
                        <option key={k} id={m.id} name={m.id} value={m.id}>{m.valor} ({m.descompte})</option>
                      )}
                    </select>
                  </td>
                  <td>
                    {quota.bonificacio >0 && "-"+(quota.bonificacio).toLocaleString(undefined, { 'maximumFractionDigits': 2 })+ "€" }
                  </td>
                </tr>
          )}

          { quota.formacio > 0 && (<tr><td className="quotaNomCamp">Despeses de formació:</td><td>{(quota.formacio).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td></tr>)}

          { /*quota.material > 0 && (<tr><td className="quotaNomCamp">Material del cicle:</td><td>{(quota.material).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td></tr>) */}


          { ( props.curs.id.startsWith("ESO") || props.curs.id.startsWith("BATX") )  ?

            (
              <>
              <tr><th colspan="2" className="quotaNomCamp">Preu curs escolar:</th></tr>
              </>

            ) 
            : 
            (
              <>
              {/* Si l'import del material és 0 no cal mostrar */}
              {!props.curs.material && (<tr><td className="quotaNomCamp"></td> </tr>)}
              {props.curs.material && (<tr><th colspan="2" className="quotaNomCamp">Material específic del cicle:</th></tr>)}
              </>
            )}

          {props.curs.material && props.curs.material.map((m, p) => {

            let disabled = false

            if ( props.assignatures?.length === 1 && /^FCT/.test(props.assignatures[0]) ) { // si només fan FCT no hi ha mai material
                return false
            } 
            else
            {

              let preu_material = 0;

              //console.log("MATERIALS",props.curs.id);

              // MATERIALS
              switch (props.curs.id) 
              {
                // ESO 1, 2, 3 i 4
                case "ESOLOE01": 
                case "ESOLOE01C":  // continuitat
                case "ESOLOE02": 
                case "ESOLOE02C":  // continuitat
                case "ESOLOE03": 
                case "ESOLOE03C":  // continuitat

                case "ESOLOE04": 
                case "ESOLOE04C":  // continuitat
                case "ESOLOE04CT":  // cientific tecnologic
                case "ESOLOE04HS":  // humanitats social
                case "ESOLOE04A":   // artistic
                case "ESOLOE04CF":  // cicles


                  if( m.id === "material")
                  {
                      //NESE B
                      if(exemptPagament(props.iddocument,props.becat) || exemptPagamentAmbLlibres(props.iddocument,props.becat))
                      { 
                        if(m.preu != 0)
                        {
                          m.info=config.textNESEB
                          m.preu = 0
                          canviaPreuMaterial(m.id, 0)
                        }
                      //} else if ( props.assignatures.length < props.assignaturesTotalsNecessaries) {
                      // TODO - REVISAR NOMBRE ASSIGNATURES
                      } 

                        disabled = true; 
                        break; 
                  }


                disabled = true; 
                break; 







                // BATX 1 i 2
                case "BATXLOE10001": 
                case "BATXLOE10002": 

                case "BATXLOE20001C": 
                case "BATXLOE20002C": 
                case "BATXLOE20001CTC": 

                case "BATXLOE20001T": 
                case "BATXLOE20002T": 

                case "BATXLOE30001H": 
                case "BATXLOE30002H": 
                case "BATXLOE30001HSC": 

                case "BATXLOE30001S": 
                case "BATXLOE30002S": 


                  if( m.id === "material")
                  {
                      //NESE B
                      if(exemptPagament(props.iddocument,props.becat) || exemptPagamentAmbLlibres(props.iddocument,props.becat))
                      { 
                        if(m.preu != 0)
                        {
                          m.info=config.textNESEB
                          m.preu = 0
                          canviaPreuMaterial(m.id, 0)
                        }
                      } 

                        disabled = true; 
                        break; 
                  }


                disabled = true; 
                break; 






                /* BATX REPETIDORS */

                case "BATXLOE10001R": 
                case "BATXLOE10002R": 

                case "BATXLOE20001CR": 
                case "BATXLOE20002CR": 

                case "BATXLOE20001TR": 
                case "BATXLOE20002TR": 

                case "BATXLOE30001HR": 
                case "BATXLOE30002HR": 

                case "BATXLOE30001SR": 
                case "BATXLOE30002SR": 


                  if( m.id === "material")
                  {
                      //console.log("MAT",props.becat)
                      //NESE B
                      if(exemptPagament(props.iddocument,props.becat) || exemptPagamentAmbLlibres(props.iddocument,props.becat))
                      { 
                        if(m.preu != 0)
                        {
                          m.info=config.textNESEB
                          m.preu = 0
                          canviaPreuMaterial(m.id, 0)
                        }
                      //} else if ( props.assignatures.length < props.assignaturesTotalsNecessaries) {
                      // TODO - REVISAR NOMBRE ASSIGNATURES
                      } else if ( props.assignatures.length < 7 ) {
                            // diurn : NO ha agafat curs complet

                            if(m.preu != 30)
                            {
                              m.preu = 30
                              canviaPreuMaterial(m.id, 30)
                            }
                      } else {
                        // diurn : SI ha agafat curs complet
                        if (props.curs.id.startsWith("BATXLOE1000")){

                          if (m.preu != 85) {
                            m.preu = 85
                            canviaPreuMaterial(m.id, 85)
                          }

                        } else {

                          if (m.preu != 65) {
                            m.preu = 65
                            canviaPreuMaterial(m.id, 65)
                          }

                        }

                      }

                        disabled = true; 
                        break; 
                  }

                  if( m.id === "ampa")
                  {
                        disabled = false; 
                        break; 
                  }

              break;


                // BATX NOCTURN
                case "BATXLOE20001NC":
                case "BATXLOE20002NC":

                case "BATXLOE30001NHS":
                case "BATXLOE30002NHS":

                case "BATXLOE20001NCR":
                case "BATXLOE20002NCR":

                case "BATXLOE30001NHSR":
                case "BATXLOE30002NHSR":

                /* BATX NOCTURN REPETIDORS */

                  if( m.id === "material")
                  {
                      //NESE B
                      if(exemptPagament(props.iddocument,props.becat) || exemptPagamentAmbLlibres(props.iddocument,props.becat))
                      { 
                        if(m.preu != 0)
                        {
                          m.info=config.textNESEB
                          m.preu = 0
                          canviaPreuMaterial(m.id, 0)
                        }
                      //} else if ( props.assignatures.length < props.assignaturesTotalsNecessaries) {
                      // TODO - REVISAR NOMBRE ASSIGNATURES
                      } else if ( props.assignatures.length < 7 ) {
                            // nocturn: NO ha agafat curs complet

                            if(m.preu != 30)
                            {
                              m.preu = 30
                              canviaPreuMaterial(m.id, 30)
                            }
                      }else {
                            // nocturn: SI ha agafat curs complet

                        if (props.curs.id.startsWith("BATXLOE1000")){

                          if (m.preu != 85) {
                            m.preu = 85
                            canviaPreuMaterial(m.id, 85)
                          }
                        } else {

                          if (m.preu != 65) {
                            m.preu = 65
                            canviaPreuMaterial(m.id, 65)
                          }

                      }

                        disabled = true; 
                        break; 
                  }
                }

                  if( m.id === "ampa")
                  {
                        disabled = false; 
                        break; 
                  }

              break;



            default:
                    disabled = true; 
                    break; 

              }
            }




            /* si els dos terminis no estan activats mostrem altres condicions de pagament */
          if(!config.dosTerminisEnabled) { props.curs.condicions = config.dosTerminisEnabledFalseCondicio } 

          return (
            <>
          <tr>
            <td>
            <input type="checkbox" id={m.id} name={m.id} value={m.preu} checked={isMaterialChecked(m.id)} disabled={disabled} onChange={(e) => handleChangeMaterial(e.target.id)} />
            <label for={m.id}>{m.txt}</label>
            </td>
            <td>
            {m.preu}&euro;
          </td></tr>


              { props.curs.id.startsWith("BATXLOE") &&  (<>

                {/* BATXILLERAT NOCTURN*/}
              { config.pattern_batx_nocturn.test(props.curs.id) &&
              (<>
                    <tr>
                      <td>
                        <div style={{ maxWidth: '75%', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }}>
                           <h3>Convalidacions per Cicle Formatiu de Grau Mitjà</h3>

                              L’alumnat que tingui un Cicle Formatiu de Grau Mitjà, poden convalidar una matèria de modalitat de primer de batxillerat, una matèria de modalitat de segon de batxillerat i el Treball de Recerca. Per això, hauran d'acudir presencialment a la Secretaria del centre amb el Resguard del títol del Cicle Formatiu i fotocòpia del Resguard i emplenar l'imprès que se li proporcionarà.
                          </div>
                      </td>
                    </tr>
                </>)}


                {/* 1r BATXILLERAT*/}
              { (config.pattern_1r_batx.test(props.curs.id) || (props.nouAlumne && config.pattern_2n_batx.test(props.curs.id)))  &&
              (<>
                    <tr>
                      <td>
                        <div style={{ maxWidth: '75%', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }}>
                           <h3>Informació sobre els llibres</h3>

                        <b>IMPORTANT: No adquiriu els llibres del Bloc Opcional, només els del Bloc Comú.<br/> Els del Bloc Opcional, s'han d'adquirir a l'inici de curs quan l'alumne/a sàpiga quines matèries del Bloc Opcional cursarà.<br/></b>

                        <br/>

                        A la pàgina principal del web del centre:
                          <ul>
                            <li>A la pàgina principal: Programa de reutilització de llibres (Iddink)</li> 
                            <li> Llista de llibres de text: Apartat “Espai famílies” → “Llibres de text”</li> 
                          </ul>
                          També trobareu informació del programa de reutilització de llibres (Iddink) a l’entrada del centre.<br/>
                          <br></br>


                          Si voleu fer ús del programa de reutilització de llibres Iddink per a l'adquisició de llibres. Podeu fer la vostra comanda a través de:<br/>
                        <ul>
                          <li>Pàgina web d'Iddink: <a href="www.iddink.cat" target="_blank">www.iddink.cat</a></li>
                          <li>Per mail: <a href="mailto:info@iddink.cat">info@iddink.cat</a></li>
                        </ul>

                          </div>
                      </td>
                    </tr>
                </>)}


              </>)}


              {/* només per nous de 1r ESO ?*/}
              { props.curs.id === "ESOLOE01" && 
              (<>
                    <tr>
                      <td>
                        <div style={{ maxWidth: '75%', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }}>
                           <h3>REUNIÓ INFORMATIVA ALUMNAT DE 1r d’ESO</h3>

                            <span dangerouslySetInnerHTML={{ __html: config.textReunioInformativa1rESO }} />
                            <br/>
                          </div>
                      </td>
                    </tr>
                    </>)}


              { props.curs.id.startsWith("ESOLOE") && 
              (<>
                 {/* Volen que la informació de NESE B surti abans des llibres, la de l'ajuntament ja va bé a sota */}
              {(exemptPagament(props.iddocument,props.becat) || exemptPagamentAmbLlibres(props.iddocument,props.becat)) &&
              (<>
                { m.info !== undefined ?
                    (<tr>
                      <td>
                        <div style={{ maxWidth: '75%', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }} dangerouslySetInnerHTML={{ __html: m.info }} />
                      </td>
                    </tr>)
                    : null
                  }
                </>)}




                  {props.nouAlumne && props.curs.id.startsWith("ESOLOE") && (exemptPagament(props.iddocument,props.becat) || exemptPagamentAmbLlibres(props.iddocument,props.becat)) ?
                  (<tr>
                    <td>
                      <div style={{ maxWidth: '75%', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }}>
                        <h3>INFORMACIÓ SOBRE ELS LLIBRES</h3>

                        <span dangerouslySetInnerHTML={{ __html: config.textInformacioLlibres1rESOBecats }} />
                        <br />

                      </div>
                    </td>
                  </tr>
                  )
                  :
                    (<tr>
                      <td>
                        <div style={{ maxWidth: '75%', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }}>
                           <h3>INFORMACIÓ SOBRE ELS LLIBRES</h3>

                          <ul>
                            <li>A la pàgina principal: Programa de reutilització de llibres (Iddink)</li> 
                            <li>Llista de llibres de text: Apartat “Espai famílies” → “Llibres de text”</li> 
                          </ul>
                          També trobareu informació del programa de reutilització de llibres (Iddink) a l’entrada del centre.<br/>
                          <br></br>


                          Si voleu fer ús del programa de reutilització de llibres Iddink per a l'adquisició de llibres. Podeu fer la vostra comanda a través de:<br/>
                        <ul>

                          <li>Pàgina web d'Iddink: <a href="www.iddink.cat" target="_blank">www.iddink.cat</a></li>
                          <li>Per mail: <a href="mailto:info@iddink.cat">info@iddink.cat</a></li>
                        </ul>

                        <p dangerouslySetInnerHTML={{ __html: config.textInformacioLlibres1rESO }} />

                          Podeu consultar aquests enllaços addicionals:
                        <ul>
                          <li>
                            <a href="https://agora.xtec.cat/ies-pompeu-fabra-martorell/documents-per-les-families/iddink/" target="_blank">https://agora.xtec.cat/ies-pompeu-fabra-martorell/documents-per-les-families/iddink/</a>
                          </li>
                          <li>
                            <a href="https://agora.xtec.cat/ies-pompeu-fabra-martorell/documents-per-les-families/llibres-de-text-curs-25-26/" target="_blank">https://agora.xtec.cat/ies-pompeu-fabra-martorell/documents-per-les-families/llibres-de-text-curs-25-26/</a>
                          </li>
                        </ul>

                          </div>
                      </td>
                    </tr>)}
              </>)}


              {!(exemptPagament(props.iddocument,props.becat) || exemptPagamentAmbLlibres(props.iddocument,props.becat)) &&
              (<>
                { m.info !== undefined ?
                    (<tr>
                      <td>
                        <div style={{ maxWidth: '75%', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }} dangerouslySetInnerHTML={{ __html: m.info }} />
                      </td>
                      <td>
                      </td>
                    </tr>)
                    : null
                  }
                </>)}

          </>
          )}
          )}




          <tr><th className="quotaNomCamp" colSpan="2"> Total a abonar a compte:</th></tr>

          <tr>

          { ( props.curs.id.startsWith("ESO") || props.curs.id.startsWith("BATX") )  ?
          (<>
           <td>Total: 
           { 
           exemptPagament(props.iddocument,props.becat) ? 
           ( <small>&nbsp;<i>Exempt de pagament de la quota de material</i></small>)
           : exemptPagamentAmbLlibres(props.iddocument,props.becat) && ( <small>&nbsp;<i>Exempt del pagament de la matrícula (material i sortides) si que s'hauran de comprar els llibres.</i></small>)}
           
            </td>
          </>)
          :
          (<>
          { quota.menor28 ? (<td>Alumnat menor de 28 anys</td>) : (<td>Alumnat de 28 anys i major: </td>)}
          </>) 
          }

           <td className="quotaTotal"> {(quota.total).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td>

          </tr>



          <tr>
          { !quota.menor28 && (<td colSpan={2}>

            <small><i>(Els alumnes més grans de 28 anys que disposin de la targeta sanitària del Servei Català de la Salut tenen coberta l'assistència sanitària, però no tenen dret a les prestacions que dona l'assegurança escolar obligatòria.)</i></small>

          </td>)}

          </tr>

          { ( props.curs.condicions === 1 && config.dosTerminisEnabled ) && 

          quota.bonificacio < quota.matricula ? 

          (<tr>
            <td colspan="2">
            <input type="checkbox" id="dosTerminis" name="dosTerminis" value={true} checked={props.dosTerminis} onChange={(e) => props.setDosTerminis(e.target.checked)} />
            <label for="dosTerminis">Vull fer el pagament en 2 terminis</label>
            </td>
            <td>
          </td></tr>)
          : (<>{props.setDosTerminis(false)}</>)

          }


           { props.dosTerminis && (
              <React.Fragment>
              <tr>
                <td>
                  Pagament 1r termini:
                </td>
                <td>
                  { quota.termini1 && (quota.termini1).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
                </td>
              </tr>
              <tr>
                <td>
                  Pagament 2n termini:
                </td>
                <td>
                  { quota.termini2 && (quota.termini2).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
                </td>
              </tr>
              </React.Fragment>
            )}

          </tbody>
        </table>

      </div>
      </div>

    </div >
  )
  
 }
